import React from 'react'

type TListMenu = {
  readonly name: string
  readonly title: string
}

type TGroupMenu = {
  readonly listMenu: TListMenu[]
  readonly selectedMenu: string
  readonly onClick: (e: string) => void
}

export default function GroupMenu({ listMenu, selectedMenu, onClick }: TGroupMenu) {
  return (
    <div className='flex flex-row justify-center overflow-x-auto bg-pop-darker'>
      <div className='flex w-full flex-row gap-3 px-5 py-5 md:px-12 lg:w-3/4 xl:w-1/2'>
        {listMenu?.map((res) =>
          res?.name === selectedMenu ? (
            <div
              className='flex cursor-pointer flex-row items-center justify-center rounded-full bg-pop-blue-700 px-3 py-1'
              key={res?.name}
            >
              <span className='text-xs font-medium text-white'>{res?.title}</span>
            </div>
          ) : (
            <button
              type='button'
              className='flex cursor-pointer flex-row rounded-full bg-white px-3 py-1 outline outline-pop-grey-200'
              key={res?.name}
              onClick={() => onClick(res?.name)}
            >
              <span className='text-xs font-medium text-pop-grey-600'>{res?.title}</span>
            </button>
          ),
        )}
      </div>
    </div>
  )
}
